import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AgmCoreModule } from '@agm/core'

import { SharedModule } from '../shared/shared.module'
import { ToolbarModule } from '../toolbar/toolbar.module'
import { MoviesModule } from '../movies/movies.module'
import { ProfileRoutingModule } from './profile-routing.module'

import { ProfileComponent } from './profile.component'
import { UserProfileComponent } from './user-profile/user-profile.component'
import { SettingsComponent } from './settings/settings.component'
import { ProfileImageComponent } from './profile-image/profile-image.component';
import { ReportOptionsDialogComponent } from './report-options-dialog/report-options-dialog.component';
import { ReportTextDialogComponent } from './report-text-dialog/report-text-dialog.component';
import { BlockedListComponent } from './blocked-list/blocked-list.component';
import { LocationComponent } from './location/location.component';
import { ConsumablesModule } from '../consumables/consumables.module';
import { InvitationModalComponent } from './invitation-modal/invitation-modal.component';

@NgModule({
  imports: [
    SharedModule,
    ToolbarModule,
    FormsModule,
    ReactiveFormsModule,
    MoviesModule,
    ProfileRoutingModule,
    ConsumablesModule,
    AgmCoreModule
  ],
  exports: [
    ProfileComponent,
    SettingsComponent,
  ],
  declarations: [
    ProfileComponent,
    UserProfileComponent,
    SettingsComponent,
    ProfileImageComponent,
    ReportOptionsDialogComponent,
    ReportTextDialogComponent,
    BlockedListComponent,
    LocationComponent,
    InvitationModalComponent,
  ],
  entryComponents: [
    ReportOptionsDialogComponent,
    ReportTextDialogComponent
  ]
})
export class ProfileModule { }




// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/profile.module.ts